import { Box, Divider, SidePanel } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context";
import { FocusManager, Panel, PanelHeader } from "./../../../ui-components";
import { MODAL_ROOT } from "../data-hooks/data-hooks";
import { AttributesMobile } from "./attributes/attributes-mobile";
import { Footer } from "./footer";
import { SectionMobile } from "./section/section-mobile";
import { TypeSelect } from "./type-select";
import { useLinkModalState } from "./use-link-modal-state";
import { WebAddress } from "./web-address";
const ModalMobile = ({
  initialValue,
  enabledLinkTypes,
  onClose,
  onSave,
  onUnlink
}) => {
  const { jsdomMode, isMobile, t } = useContext(RicosContext);
  const {
    link,
    linkType,
    submitError,
    onChangeAttributes,
    onChangeWebAddress,
    onClickUnlink,
    onSelectSection,
    onSelectType,
    onSubmit,
    onValidateWebAddress
  } = useLinkModalState({ initialValue, onClose, onSave, onUnlink });
  return /* @__PURE__ */ React.createElement(FocusManager, { isMobile, jsdomMode }, /* @__PURE__ */ React.createElement(
    Panel,
    {
      dataHook: MODAL_ROOT,
      height: "100%",
      onCloseButtonClick: onClose,
      skin: "floating",
      width: "100%"
    },
    /* @__PURE__ */ React.createElement(PanelHeader, { title: t("LinkSettings_Modal_Title") }),
    /* @__PURE__ */ React.createElement(SidePanel.Content, { noPadding: true }, /* @__PURE__ */ React.createElement(Box, { boxSizing: "border-box", direction: "vertical", gap: "SP3", height: "100%", padding: 0 }, /* @__PURE__ */ React.createElement(Box, { padding: "SP3", paddingBottom: 0 }, enabledLinkTypes && enabledLinkTypes.length === 1 ? null : /* @__PURE__ */ React.createElement(
      TypeSelect,
      {
        autoFocus: false,
        onSelect: onSelectType,
        showSitePages: false,
        t,
        type: linkType,
        enabledLinkTypes
      }
    )), linkType === "section" ? /* @__PURE__ */ React.createElement(SectionMobile, { link, onSelect: onSelectSection, t }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { direction: "vertical", paddingLeft: "SP3", paddingRight: "SP3" }, /* @__PURE__ */ React.createElement(
      WebAddress,
      {
        autoFocus: true,
        link,
        onChangeUrl: onChangeWebAddress,
        onValidateUrl: onValidateWebAddress,
        submitError,
        t
      }
    )), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3" }, /* @__PURE__ */ React.createElement(AttributesMobile, { link, onChange: onChangeAttributes, t }))))),
    /* @__PURE__ */ React.createElement(SidePanel.Footer, { showDivider: true }, /* @__PURE__ */ React.createElement(
      Footer,
      {
        onClickCancel: onClose,
        onClickSave: onSubmit,
        onClickUnlink,
        showUnlink: !!initialValue,
        t
      }
    ))
  ));
};
export {
  ModalMobile
};
//# sourceMappingURL=modal-mobile.js.map
